export default __webpack_public_path__ + "static/media/icon_left_simple_round_20_Regular.f8770e2d.svg";